import { BaseModel } from '../../_base/crud';
import { Address } from './address.model';

export class PreBuildTier extends BaseModel {
  userId: string;
  nodeDataArrayJSON: string;
  PreBuildTierName: string;
  image: string;

  clear(): void {
    this.nodeDataArrayJSON = '';
    this.userId = '';
    this.image = '';
    this.PreBuildTierName = '';
  }
}
